import { Injectable } from '@angular/core';
import { ScreenModel } from '../Models/screen-model';
import { ScreenStore } from '../DataStore/App/screen-store';

@Injectable({
  providedIn: 'root'
})
export class ScreenService {

  constructor() { }


  public findByObjectId(id: string):ScreenModel{
    return ScreenStore.findByObjectId(id);

  }

  public findById(id:number):ScreenModel{
      return ScreenStore.findById(id);
  }

  public getItems():ScreenModel[]{
    return ScreenStore.getItems();
  }
}
